import { render, staticRenderFns } from "./ProductPoolGood.vue?vue&type=template&id=0c12ab96&"
import script from "./ProductPoolGood.vue?vue&type=script&lang=js&"
export * from "./ProductPoolGood.vue?vue&type=script&lang=js&"
import style0 from "./ProductPoolGood.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports